import {
  styled,
  Card,
  CardContent,
  ListItemButton,
  ListItemText,
  listItemTextClasses,
} from '@mui/material';

export const classes = {
  expanded: 'AssistantGenerateRoutesDialogCollapsableCard-expanded',
  expandIcon: 'AssistantGenerateRoutesDialogCollapsableCard-expandIcon',
};

export const AssistantGenerateRoutesDialogCollapsableCardContainer = styled(
  Card,
)({
  display: 'grid',
  width: '100%',
});

export const AssistantGenerateRoutesDialogCollapsableCardContent = styled(
  CardContent,
)(({ theme }) => ({
  padding: theme.spacing(1, 2),
  display: 'grid',
  gridTemplateRows: 'max-content 1fr',

  '&:last-child': {
    paddingBottom: theme.spacing(1),
  },
}));

export const AssistantGenerateRoutesDialogCollapsableCardHeader = styled(
  ListItemButton,
)(({ theme }) => ({
  padding: 0,

  '&:hover': {
    textDecoration: 'none',
    backgroundColor: 'transparent',
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent',
    },
  },

  [`& .${classes.expandIcon}`]: {
    fontSize: theme.typography.pxToRem(20),
    color: theme.palette.action.active,
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shorter,
    }),
  },

  [`&.${classes.expanded} .${classes.expandIcon}`]: {
    transform: 'rotate(180deg)',
  },
}));

export const AssistantGenerateRoutesDialogCollapsableCardHeaderText = styled(
  ListItemText,
)(({ theme }) => ({
  margin: 0,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),

  [`& .${listItemTextClasses.primary}`]: {
    ...theme.typography.subtitle2,
    fontWeight: theme.typography.fontWeightBold,
  },

  [`& .${listItemTextClasses.secondary}`]: {
    ...theme.typography.subtitle2,
    fontSize: theme.typography.pxToRem(10),
    fontWeight: theme.typography.fontWeightBold,
  },
}));
